<template>
	<div>
		<!-- <v-navigation-drawer disable-resize-watcher v-model="sidebar" app>
			<v-list>
				<v-list-item v-for="item in menu" :key="item.title" :to="item.link">
					<v-list-item-content>{{ item.title }}</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer> -->
		<v-navigation-drawer disable-resize-watcher v-model="sidebar" app>
			<v-list>
				<v-list-group
					v-if="menu.some(item => item.title === 'Audit')"
					no-action
				>
					<template v-slot:activator>
						<v-list-item-content>
							<v-list-item-title>Audit</v-list-item-title>
						</v-list-item-content>
					</template>
					<v-list-item
						v-for="type in moduleDetails.audit.types"
						:key="type.name"
						:to="type.to"
						class="pl-8"
					>
					<v-list-item-content>
						<v-list-item-title>{{ type.name }}</v-list-item-title>
					</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<!-- Render all other menu items except Audit -->
				<v-list-item
					v-for="item in nonAuditMenuItems"
					:key="item.title"
					:to="item.link"
				>
					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-app-bar
			app
			color="#EEEEEE"
			light
			elevation="0"
			prominent
			dense
			class="px-4"
			:class="{ 'nav-bar--with-company-logo': !!companyLogoUrl }"
			z-index="999999"
		>
			<v-icon class="hidden-lg-and-up mr-3" style="margin-top: 30px; " v-on:click="sidebar = !sidebar"
				>fas fa-bars</v-icon
			>
			<v-badge
				:content="env"
				:value="env"
				color="env"
				inline
				tile
				class="h-100"
			>
				<div class="d-flex align-center nav-brand-row" :class="{ 'nav-brand-row--with-logo': !!companyLogoUrl }">
					<router-link v-if="portalButton" to="/">
						<v-img
							alt="Orixe Logo"
							:src="require('../assets/Logo_teal_stacked_0.25x-removebg-preview.png')"
							width="180"
						/>
					</router-link>
					<v-img
						v-else
						alt="Orixe Logo"
						:src="require('../assets/Logo_Header.svg')"
						width="180"
					/>
					<div v-if="companyLogoUrl" class="company-logo-slot ml-4">
						<v-img
							:src="companyLogoUrl"
							alt="Company logo"
							contain
							max-width="56"
							max-height="40"
							width="56"
							height="40"
						/>
					</div>
				</div>
			</v-badge>

			<v-menu
				offset-y
				class="h-100 mx-2"
				right
				v-model="moduleMenuActive"
				v-if="onAny"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						class="hidden-sm-and-down ml-8"
						:ripple="false"
						text
						v-bind="attrs"
						v-on="on"
						large
					>
						<v-avatar
							:color="currentModule.color"
							rounded
							class="my-auto mr-4"
							size="48"
							><span class="white--text text-h5">{{
								currentModule.shortName
							}}</span></v-avatar
						>
						<span style="color: #363636; font-size: 1.2em; font-weight: 500;">
							{{ currentModule.name }}
						</span>
						<v-icon class="mt-1" small right v-if="moduleMenuActive">
							fas fa-chevron-up
						</v-icon>
						<v-icon class="mt-1" small right v-else>
							fas fa-chevron-down
						</v-icon>
					</v-btn>
				</template>
				<v-list class="py-0">
					<template v-for="(value, key) in unlockedModuleDetails">
						<!-- For Audit module with this.types -->
						<template v-if="key === 'audit' && value.types">
							<v-list-group
								:key="key"
								class="py-2"
								@click="moduleDetails = true"
							>
								<template v-slot:activator>
									<v-list-item-title>
										<v-avatar
										:color="value.color"
										rounded
										class="my-auto mr-4"
										size="56"
										>
										<span class="white--text text-h6">{{ value.shortName }}</span>
										</v-avatar>
										<span >{{ value.name }}</span>
									</v-list-item-title>
								</template>
								<v-list-item
									v-for="type in value.types"
									:key="type.name"
									:to="type.to"
									class="py-2 pl-16"
									active-class="custom-active-submenu"
									@click="clickAuditModule()"
									>
									<v-list-item-title>
										{{ type.name }}
									</v-list-item-title>
								</v-list-item>
							</v-list-group>
						</template>
						<!-- For other modules -->
						<v-list-item
							v-else
							:key="key"
							:to="value.to"
							:href="value.href"
							:target="value.target"
							class="py-2"
						>
							<v-list-item-title>
								<v-avatar
								:color="value.color"
								rounded
								class="my-auto mr-4"
								size="56"
								><span class="white--text text-h6">{{ value.shortName }}</span>
								</v-avatar>
								{{ value.name }}
							</v-list-item-title>
						</v-list-item>
					</template>
				</v-list>
			</v-menu>

			<template
				v-if="menu.length && onNis"
			>
				<v-tabs
					v-model="selectedTab"
					background-color="#EEEEEE"
					class="barUnder hidden-md-and-down nis-module-tabs"
					light
					hide-slider
				>
					<v-tab
						v-for="(item, index) in menu"
						:key="index"
						:to="item.link"
						:href="item.href"
						:exact="item.exact !== false"
						v-bind:target="!!item.href ? '_blank' : ''"
						v-bind:class="{ activeBar: selectedItem(item) }"
					>
						{{ item.title }}
					</v-tab>
				</v-tabs>
			</template>

			<v-spacer></v-spacer>

			<template
				v-if="menu.length && (onSustainability || onAudit || onAuditFlowDown || onAuditOnsite || onEmissions)"
			>
				<!-- v-tabs for Sustainability module -->
				<v-tabs
					v-model="selectedTab"
					background-color="#EEEEEE"
					class="barUnder hidden-md-and-down"
					light
				>
					<v-tab
						v-for="(item, index) in menu"
						:key="index"
						:to="item.link"
						:href="item.href"
						:exact="true"
						v-bind:target="!!item.href ? '_blank' : ''"
						v-bind:class="{ activeBar: selectedItem(item) }"
					>
						{{ item.title }}
					</v-tab>
				</v-tabs>
			</template>
			<template v-else-if="menu.length && !onNis">
				<div
					class="nav-menu-scroll-container h-100 barUnder hidden-md-and-down"
					:class="{ 'nav-menu-scroll-container--scrollable': menuNeedsScrollArrows }"
				>
					<v-btn
						v-show="menuNeedsScrollArrows && canScrollMenuLeft"
						icon
						small
						class="nav-menu-scroll-arrow"
						@click="scrollMenuTabs('left')"
					>
						<v-icon small>fas fa-chevron-left</v-icon>
					</v-btn>
					<div
						ref="menuScrollArea"
						class="nav-menu-scroll-area"
						@scroll="updateMenuScrollArrows"
					>
						<template v-for="item in menu">
							<!-- Audit dropdown -->
							<v-menu
								v-if="item.title === 'Audit'"
								:key="item.title"
								offset-y
								class="nav-menu-scroll-item"
								v-model="auditMenuActive"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										class="barUnder"
										:ripple="false"
										text
										v-bind="attrs"
										v-on="on"
										v-bind:class="{ activeBar: selectedItem(item) }"
									>
									<span class="nav-menu-tab-label">
										{{ item.title }}
									</span>
									<v-icon small right v-if="auditMenuActive">fas fa-chevron-up</v-icon>
									<v-icon small right v-else>fas fa-chevron-down</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item to="/audit" exact>
										<v-list-item-title>Digital-Audit</v-list-item-title>
									</v-list-item>
									<v-list-item to="/auditonsite" exact>
										<v-list-item-title>Onsite-Audit</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>

							<!-- Regular button for non-audit items -->
							<v-btn
								v-else
								:key="item.title"
								:to="item.link"
								:href="item.href"
								:ripple="false"
								class="barUnder nav-menu-scroll-item"
								v-bind:target="!!item.href ? '_blank' : ''"
								text
								v-bind:class="{ activeBar: selectedItem(item) }"
							>
								<span class="nav-menu-tab-label">
									{{ item.title }}
								</span>
							</v-btn>
						</template>
					</div>
					<v-btn
						v-show="menuNeedsScrollArrows && canScrollMenuRight"
						icon
						small
						class="nav-menu-scroll-arrow"
						@click="scrollMenuTabs('right')"
					>
						<v-icon small>fas fa-chevron-right</v-icon>
					</v-btn>
				</div>
			</template>
			<v-menu
				v-if="!hideNotifications"
				:nudge-bottom="40"
				:nudge-width="-50"
				offset-y
				:close-on-content-click="false"
				class="h-100"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-badge
						:content="$store.getters['notifications/notifications/unread']"
						:value="$store.getters['notifications/notifications/unread']"
						color="red"
						overlap
						offset-x="20"
						offset-y="10"
						class="my-auto mx-2"
					>
						<v-btn
							class="hidden-sm-and-down"
							:ripple="false"
							icon
							color="#8C8C8C"
							v-bind="attrs"
							v-on="on"
							x-large
						>
							<v-icon>
								fas fa-bell
							</v-icon>
						</v-btn>
					</v-badge>
				</template>
				<v-card class="pa-2">
					<v-card-title>Latest Notifications</v-card-title>
					<notifications class="ma-1" :shouldMarkAsRead="true"></notifications>
				</v-card>
			</v-menu>
			<v-menu
				offset-y
				class="h-100 mx-2"
				:nudge-top="10"
				:nudge-left="30"
				open-on-hover
				right
				v-model="userMenuActive"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						class="hidden-sm-and-down mx-2"
						:ripple="false"
						icon
						color="#8C8C8C"
						v-bind="attrs"
						v-on="on"
						x-large
					>
						<v-icon>
							fas fa-user-circle
						</v-icon>
						<v-icon small v-if="userMenuActive">
							fas fa-chevron-up
						</v-icon>
						<v-icon small v-else>
							fas fa-chevron-down
						</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item
						to="/knowledge"
						target="_blank"
					>
						<v-list-item-title>Get help</v-list-item-title>
					</v-list-item>
					<v-list-item to="/team" exact>
						<v-list-item-title>My team</v-list-item-title>
					</v-list-item>
					<v-list-item to="/team/settings" exact>
						<v-list-item-title>Company Profile</v-list-item-title>
					</v-list-item>
					<v-list-item to="/ProductPlan" exact>
						<v-list-item-title>Product Plans</v-list-item-title>
					</v-list-item>
					<v-divider></v-divider>
					<v-list-item to="/logout">
						<v-list-item-title>Log out</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>
<script>
import getEnv from "../utils/env"
export default {
	name: "NavigationBar",
	props: {
		menuItems: Array,
		portalButton: Boolean,
		hideNotifications: Boolean,
	},
	data: () => ({
		sidebar: false,
		menu: [],
		userMenuActive: false,
		moduleMenuActive: false,
		auditMenuActive: false,
		canScrollMenuLeft: false,
		canScrollMenuRight: false,
		moduleDetails: {
			audit: {
				name: "Audit",
				shortName: "Ad",
				color: "audit",
				types: [
					{
						name: "Digital Audit",
						shortName: "Ad",
						color: "audit",
						to: "/audit"
					},
					{
						name: "Onsite Audit",
						shortName: "AdO",
						color: "audit",
						to: "/auditonsite"
					}
				]
			},
			auditFlowDown: {
				name: "Audit Flow-Down",
				shortName: "AdF",
				color: "audit",
				to: "/auditflowdown",
			},
			trace: {
				name: "Trace",
				shortName: "Tr",
				color: "trace",
				to: "/trace",
			},
			sustainability: {
				name: "Sustainability",
				shortName: "Su",
				color: "sustainability",
				to: "/csr",
			},
			nis: {
				name: "NIS",
				shortName: "NIS",
				color: "nis",
				to: "/nis",
			},
			emissions: {
				name: "Co2 Calculator",
				shortName: "Co2",
				color: "sustainability",
				to: "/emissions",
			},
			/* chain: {
				name: "Chain",
				shortName: "Ch",
				color: "chain",
				href: "/chain",
				target: "_blank",
			}, */
			connections: {
				name: "Connections",
				shortName: "Co",
				color: "connections",
				to: "/connections"
			},
			supplierPerformance: {
				name: "Supplier Performance",
				shortName: "Sp",
				color: "supplierPerformance",
				to: "/supplier-performance",
			},
		}
	}),
	mounted() {
		for (let item of this.menuItems) {
			// Always show NIS in top tabs; users without access still see it (locked)
			if (
				item.title === "NIS" ||
				!item.link ||
				this.$accessToRoute(item.link)
			) {
				this.menu.push(item)
			}
		}
		this.initializeSelectedTab()
		this.$nextTick(() => {
			this.updateMenuScrollArrows()
			window.addEventListener("resize", this.updateMenuScrollArrows)
		})
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.updateMenuScrollArrows)
	},
	watch: {
		menu() {
			this.$nextTick(this.updateMenuScrollArrows)
		},
		$route() {
			this.$nextTick(this.updateMenuScrollArrows)
		},
		menuNeedsScrollArrows() {
			this.$nextTick(this.updateMenuScrollArrows)
		},
	},
	computed: {
		env() {
			if (getEnv("VUE_APP_ENVIRONMENT_BANNER")) {
				return (getEnv("VUE_APP_ENVIRONMENT_BANNER") + " Version").toUpperCase()
			} else {
				return null
			}
		},
		auditUnlocked() {
			return this.$accessToRoute("/audit")
		},
		auditOnsiteUnlocked() {
			return this.$accessToRoute("/auditonsite")
		},
		auditFlowDownUnlocked() {
			return this.$accessToRoute("/auditflowdown")
		},
		traceUnlocked() {
			return this.$accessToRoute({ name: "Trace" })
		},
		connectionsUnlocked() {
			return this.$accessToRoute("/connections")
		},
		supplierPerformanceUnlocked() {
			return this.$accessToRoute("/supplier-performance")
		},
		sustainabilityUnlocked() {
			return this.$accessToRoute({ name: "Sustainability" })
		},
		nisUnlocked() {
			return this.$accessToRoute({ name: "NIS" })
		},
		onTrace() {
			return /^\/trace(?:\/(.*))?$/.test(this.$route.path)
		},
		onAudit() {
			return /^\/audit(?:\/(.*))?$/.test(this.$route.path)
		},
		onAuditOnsite() {
			return /^\/auditonsite(?:\/(.*))?$/.test(this.$route.path)
		},
		onAuditFlowDown() {
			return /^\/auditflowdown(?:\/(.*))?$/.test(this.$route.path)
		},
		onConnections() {
			return /^\/connections(?:\/(.*))?$/.test(this.$route.path)
		},
		onSupplierPerformance() {
			return /^\/supplier-performance(?:\/(.*))?$/.test(this.$route.path)
		},
		onSustainability() {
			return /^\/csr(?:\/(.*))?$/.test(this.$route.path)
		},
		onNis() {
			return /^\/nis(?:\/(.*))?$/.test(this.$route.path)
		},
		onEmissions() {
			return /^\/emissions(?:\/(.*))?$/.test(this.$route.path)
		},
		menuNeedsScrollArrows() {
			return this.onConnections
		},
		onAny() {
			return (
				this.onTrace ||
				this.onAudit ||
				this.onAuditOnsite ||
				this.onAuditFlowDown ||
				this.onConnections ||
				this.onSupplierPerformance ||
				this.onSustainability ||
				this.onNis ||
				this.onEmissions
			)
		},
		currentModule() {
			if (this.onTrace) {
				return this.moduleDetails.trace
			} else if (this.onAudit) {
				return this.moduleDetails.audit.types[0]
			} else if (this.onAuditOnsite) {
				return this.moduleDetails.audit.types[1] 
			} else if (this.onAuditFlowDown) {
				return this.moduleDetails.auditFlowDown
			} else if (this.onConnections) {
				return this.moduleDetails.connections
			} else if (this.onSupplierPerformance) {
				return this.moduleDetails.supplierPerformance
			} else if (this.onSustainability) {
				return this.moduleDetails.sustainability
			} else if (this.onNis) {
				return this.moduleDetails.nis
			} else if (this.onEmissions) {
				return this.moduleDetails.emissions
			} else {
				return null
			}
		},
		unlockedModuleDetails() {
			let unlockedModules = {}
			for (let key in this.moduleDetails) {
				if (this.isUnlocked(key)) {
					unlockedModules[key] = this.moduleDetails[key]
				}
			}
			return unlockedModules
		},
		companyLogoUrl() {
			return this.$store.getters["user/getUser"].companyLogo
		},
		nonAuditMenuItems() {
			return this.menu.filter(item => item.title !== "Audit")
		}
	},
	methods: {
		clickAuditModule(){
			window.location.reload()
		},
		initializeSelectedTab() {
			// Match the current route with a menu item, if available
			const matchedItem = this.menu.find(item => this.selectedItem(item))
			if (matchedItem) {
				this.selectedTab = matchedItem
			} else {
				this.selectedTab = null
			}
		},
		selectedItem(item) {
			if (!item.link) {
				return false
			}
			const path = this.$route.path
			if (Array.isArray(item.match) && item.match.length) {
				const matched = item.match.some(
					prefix => path === prefix || path.startsWith(prefix + "/")
				)
				if (matched) {
					return true
				}
			}
			if (!this.$router.resolve(item.link)) {
				return false
			}
			return this.$router.resolve(item.link).href == path
		},
		isUnlocked(module) {
			switch (module) {
			case "trace":
				return this.traceUnlocked
			case "audit":
				return this.auditUnlocked
			case "auditonsite":
				return this.auditOnsiteUnlocked
			case "auditflowdown":
				return this.auditFlowDownUnlocked
			case "connections":
				return this.connectionsUnlocked
			case "supplierPerformance":
				return this.supplierPerformanceUnlocked
			case "sustainability":
				return this.sustainabilityUnlocked
			case "nis":
				return this.nisUnlocked
			default:
				return true
			}
		},
		updateMenuScrollArrows() {
			if (!this.menuNeedsScrollArrows) {
				this.canScrollMenuLeft = false
				this.canScrollMenuRight = false
				return
			}
			const el = this.$refs.menuScrollArea
			if (!el) {
				this.canScrollMenuLeft = false
				this.canScrollMenuRight = false
				return
			}
			const maxScroll = el.scrollWidth - el.clientWidth
			this.canScrollMenuLeft = el.scrollLeft > 2
			this.canScrollMenuRight = maxScroll - el.scrollLeft > 2
		},
		scrollMenuTabs(direction) {
			const el = this.$refs.menuScrollArea
			if (!el) {
				return
			}
			const amount = Math.max(160, el.clientWidth * 0.55)
			el.scrollBy({
				left: direction === "right" ? amount : -amount,
				behavior: "smooth",
			})
			window.setTimeout(this.updateMenuScrollArrows, 300)
		},
	},
}
</script>

<style scoped>
.v-tabs {
	height: 100%;
	align-self: stretch;
	border-bottom: 4px solid transparent;
	display: flex;
	justify-content: flex-end; /* Align tabs to the right */
}

.nis-module-tabs {
	flex: 0 0 auto !important;
	width: auto !important;
	max-width: none !important;
	justify-content: flex-start !important;
	margin-left: 8px;
}

.nis-module-tabs ::v-deep .v-tabs-bar,
.nis-module-tabs ::v-deep .v-slide-group__content {
	width: auto !important;
	flex: 0 0 auto !important;
	justify-content: flex-start !important;
}
.nis-module-tabs ::v-deep .v-tab {
	min-width: auto;
	padding: 0 16px;
}
.nis-module-tabs ::v-deep .activeBar {
	border-bottom: 3px solid #1e7c83 !important;
}

.v-tab {
	text-transform: none;
	font-family: Sarabun;
	font-size: 16px;
	font-weight: 500;
	color: #363636 !important;
	font-weight: 500;
}


.v-btn {
	text-transform: none !important;
	height: 100% !important;
	border-radius: 0 !important;
}
.v-btn::before {
	background-color: transparent;
}
.barUnder {
	border-bottom: 4px solid transparent;
}
.blankBarUnder {
	border-bottom: 4px solid transparent;
}

.activeBar {
	border-bottom: 2px solid #1e7c83;
}

.logo-text {
	font-weight: 500;
	font-size: 18pt;
	margin-top: -10px;
}
.text-small {
	font-size: 14px;
	position: absolute;
	margin-left: 90px;
	color: #fff;
	font-weight: 100;
}
.h-100 {
	height: 100%;
}
.custom-active-submenu {
  color: #363636 !important;
}

.nav-menu-scroll-container {
	display: flex;
	align-items: center;
	align-self: stretch;
	height: 100%;
	flex: 0 1 auto;
	min-width: 0;
	justify-content: flex-end;
	position: relative;
	z-index: 1;
	background-color: #eeeeee;
}

.nav-menu-scroll-container--scrollable {
	flex: 1 1 auto;
	max-width: min(52vw, 720px);
	overflow: hidden;
}

.nav-menu-scroll-area {
	display: flex;
	align-items: center;
	height: 100%;
	flex-wrap: nowrap;
}

.nav-menu-scroll-container--scrollable .nav-menu-scroll-area {
	overflow-x: auto;
	overflow-y: hidden;
	scroll-behavior: smooth;
	scrollbar-width: none;
	-ms-overflow-style: none;
}

.nav-menu-scroll-container--scrollable .nav-menu-scroll-area::-webkit-scrollbar {
	display: none;
}

.nav-menu-scroll-area >>> .v-btn {
	height: 48px !important;
	min-height: 48px !important;
	max-height: 56px !important;
	display: inline-flex !important;
	align-items: center !important;
	justify-content: center !important;
}

.nav-menu-scroll-area >>> .v-btn .v-btn__content {
	display: inline-flex !important;
	align-items: center !important;
	justify-content: center !important;
	height: 100%;
	line-height: 1.2;
}

.nav-menu-scroll-area >>> .v-menu {
	height: auto;
	display: flex;
	align-items: center;
}

.nav-menu-scroll-item {
	flex: 0 0 auto;
	white-space: nowrap;
}

.nav-menu-tab-label {
	color: #363636;
	font-size: 16px;
	font-weight: 500;
	line-height: 1.2;
	display: inline-flex;
	align-items: center;
}

.nav-menu-scroll-arrow {
	flex: 0 0 auto;
	align-self: center;
	color: #616161 !important;
	margin: 0 2px;
}

.nav-brand-row {
	max-height: 56px;
	overflow: hidden;
	align-items: center;
}

.company-logo-slot {
	flex: 0 0 auto;
	width: 56px;
	height: 40px;
	max-width: 56px;
	max-height: 40px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	background: transparent;
}

.company-logo-slot >>> .v-image,
.company-logo-slot >>> .v-responsive {
	max-width: 56px !important;
	max-height: 40px !important;
}

/* Tabs stay compact and opaque so a large logo cannot stretch or show through Audit */
.nav-menu-scroll-area >>> .v-btn.barUnder {
	background-color: #eeeeee !important;
}
</style>
